import React from "react";
import image1 from "../../../Assets/Compliance Certifictes/image.png";
import image2 from "../../../Assets/Compliance Certifictes/image2.png";

const CEInfoContainer = () => {
  return (
    <div className="w-full h-auto px-4 sm:px-10 grid grid-cols-1 xl:grid-cols-2 gap-8 bg-[#F7FAFF]">
      {/* left side */}
      <div className="w-full">
        {/* heading */}
        <div className="py-4 md:py-10">
          <div className="text-[#032303] font-bold sm:text-3xl md:font-medium text-lg md:text-4xl">
            <h1 className="">
              <span className="border-b-4 border-[#249742]"></span>
              GET CE MARKING CERTIFICATION IN MUMBAI
            </h1>
          </div>
        </div>

        {/* content */}
        <div>
          <p className="font-normal text-lg text-[#4D4D4D]">
            The letters ‘CE’ appear on many products traded on the extended
            Single Market in the European Economic Area (EEA). They signify that
            products sold in the EEA have been assessed to meet high safety,
            health, and environmental protection requirements. When you buy a
            new phone, a teddy bear, or a TV within the EEA, you can find the CE
            mark on them. CE marking also supports fair competition by holding
            all companies accountable to the same rules.
          </p>

          <p className="font-normal text-lg text-[#4D4D4D] py-2">
            By affixing the CE marking to a product, a manufacturer declares
            that the product meets all the legal requirements for CE marking and
            can be sold throughout the EEA. This also applies to products made
            in other countries that are sold in the EEA.
          </p>

          <p className="font-normal text-lg text-[#4D4D4D] py-2">
            There are two main benefits CE marking brings to businesses and
            consumers within the EEA:
          </p>

          <p className="font-normal text-lg text-[#4D4D4D] py-2">
            Businesses know that products bearing the CE marking can be traded
            in the EEA without restrictions.
          </p>

          <p className="font-normal text-lg text-[#4D4D4D] py-2">
            Consumers enjoy the same level of health, safety, and environmental
            protection throughout the entire EEA.
          </p>
        </div>
      </div>

      {/* right side */}
      <div className="grid sm:grid-cols-2 grid-cols-1 gap-4">
        <div className="py-0 sm:py-8">
          <img
            src={image2}
            className="rounded-2xl w-full h-[421px] object-cover transition-transform duration-300 ease-in-out hover:scale-[1.02] hover:shadow-lg cursor-pointer"
            alt="Compliance certificate"
            loading="lazy"
          />
        </div>

        <div className="py-0 sm:py-8">
          <img
            src={image1}
            className="rounded-2xl w-full h-[421px] object-cover transition-transform duration-300 ease-in-out hover:scale-[1.02] hover:shadow-lg cursor-pointer"
            alt="Compliance certificate"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
};

export default CEInfoContainer;
